// Generated hero art for the page headers that have no content to draw on.
//
// The pattern started on /learnings, whose hero grid is filled with the covers
// of the four newest articles — content-driven, so it refreshes itself and
// costs nothing. /reviews, /projects and /podcast work the same way. Prefer
// that wherever a page has real imagery: these constants are the fallback for
// headers where the alternative is an empty column.
//
// Generated with `node scripts/generate-hero-art.mjs --page <key> --scenes
// scripts/hero-scenes.json`, using the house watercolour style in
// strategy/image_strategy.md, so they sit in the same world as the article
// covers next to them. The scenes live in scripts/hero-scenes.json — edit there
// and re-run to replace a tile, rather than hand-editing URLs here.
//
// Long-cached immutable URLs (a fresh hash per upload), so replacing art means
// a new URL, never a stale-cache surprise.

export const HERO_ART = {
  // sketching a system diagram · pairing at one laptop · a desk of architecture notes · reading on the sofa
  home: [
    'https://assets.gazar.dev/hero-home-1_0289e553.png',
    'https://assets.gazar.dev/hero-home-2_81a2c818.png',
    'https://assets.gazar.dev/hero-home-3_c94aa27b.png',
    'https://assets.gazar.dev/hero-home-4_1ee858f9.png',
  ],
  // a one-to-one over coffee · explaining at a whiteboard · a video call · walking and talking
  mentorship: [
    'https://assets.gazar.dev/hero-mentorship-1_bbbe46d7.png',
    'https://assets.gazar.dev/hero-mentorship-2_ac16c8cb.png',
    'https://assets.gazar.dev/hero-mentorship-3_2ae2b377.png',
    'https://assets.gazar.dev/hero-mentorship-4_c64c19a4.png',
  ],
  // on stage · at the lectern · the room from the back · the chat afterwards
  talks: [
    'https://assets.gazar.dev/hero-talks-1_ed2208c7.png',
    'https://assets.gazar.dev/hero-talks-2_944aa815.png',
    'https://assets.gazar.dev/hero-talks-3_60918a9f.png',
    'https://assets.gazar.dev/hero-talks-4_fb8fbfbf.png',
  ],
  // a handshake · a team laughing · reading a good message · a quiet win
  testimonials: [
    'https://assets.gazar.dev/hero-testimonials-1_d3687feb.png',
    'https://assets.gazar.dev/hero-testimonials-2_046195cf.png',
    'https://assets.gazar.dev/hero-testimonials-3_00e5cae8.png',
    'https://assets.gazar.dev/hero-testimonials-4_b9342e9d.png',
  ],
  // an open message window · writing at the kitchen table · an envelope and pen · waving hello on a call
  contact: [
    'https://assets.gazar.dev/hero-contact-1_78a63077.png',
    'https://assets.gazar.dev/hero-contact-2_f8f8683d.png',
    'https://assets.gazar.dev/hero-contact-3_7fdf9ef4.png',
    'https://assets.gazar.dev/hero-contact-4_e44d5bd3.png',
  ],
  // teaching to a webcam · watching a replay · a whiteboard diagram · a call grid
  lessons: [
    'https://assets.gazar.dev/hero-lessons-1_e25c5027.png',
    'https://assets.gazar.dev/hero-lessons-2_c339ddae.png',
    'https://assets.gazar.dev/hero-lessons-3_e0ec99ea.png',
    'https://assets.gazar.dev/hero-lessons-4_9206fddc.png',
  ],
  // gently lost with a map — the 404
  notfound: ['https://assets.gazar.dev/hero-notfound-1_5764819a.png'],
  // an empty card-catalogue drawer — a search with no matches
  searchempty: ['https://assets.gazar.dev/hero-searchempty-1_428c5571.png'],
  // a workbench of finished things · a shipped dashboard · wireframes in a notebook · tools beside a laptop
  projects: [
    'https://assets.gazar.dev/hero-projects-1_6ae221b6.png',
    'https://assets.gazar.dev/hero-projects-2_16aa09e7.png',
    'https://assets.gazar.dev/hero-projects-3_cfd84bd7.png',
    'https://assets.gazar.dev/hero-projects-4_61c3c89e.png',
  ],
} satisfies Record<string, string[]>

// Share cards, one per page. Every page used to fall back to a single
// site-wide default, so a /lessons link and a /mentorship link looked identical
// in a LinkedIn feed.
//
// Drawn at 16:9 rather than reusing a hero tile: social cards are ~1.91:1 and
// crop a 4:3 image top and bottom, through the subject. Generate with
// `--og`; articles don't appear here because they already share their own cover.
export const OG_IMAGE = {
  home: 'https://assets.gazar.dev/og-home_c491a59e.png',
  mentorship: 'https://assets.gazar.dev/og-mentorship_2cfcb51d.png',
  talks: 'https://assets.gazar.dev/og-talks_52ad716f.png',
  testimonials: 'https://assets.gazar.dev/og-testimonials_39985119.png',
  contact: 'https://assets.gazar.dev/og-contact_3cb591b6.png',
  lessons: 'https://assets.gazar.dev/og-lessons_6f4589cb.png',
  projects: 'https://assets.gazar.dev/og-projects_0912b26b.png',
  learnings: 'https://assets.gazar.dev/og-learnings_4d34fd51.png',
  reviews: 'https://assets.gazar.dev/og-reviews_150b520c.png',
  podcast: 'https://assets.gazar.dev/og-podcast_632da03b.png',
  courses: 'https://assets.gazar.dev/og-courses_c4fc29c6.png',
} satisfies Record<string, string>
